const StatusPill = ({
    label,
    color,
}) => (
    <span
        className="overview-esg-rating__pill"
        style={{ backgroundColor: color }}
    >
        {label}
    </span>
);

export default StatusPill;
